import swal from 'sweetalert2';
import { Redirect } from 'react-router-dom';
import { publicRoutesPath } from '../Routes';
import history from './history';
export const sessionExpiredDialog = () => {
   return new swal({
        width: 350,
        padding: 10,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: 'black',
        text: 'Current session is expired. ',
        type: 'warning',
        confirmButtonText: 'Login',
    }).then(function() {
        localStorage.removeItem('accessToken');
        history.push(publicRoutesPath.LOGIN);
    })
}